export default __webpack_public_path__ + "static/media/Visual data-bro.10445920.svg";